<template>
    <div class="mb-2">
        <input type="button" @click="adicionarEstilo" class="btn btn-success" value="Criar">
    </div>
</template>
<script>

export default {

    data: function () {
        return {

            loading: false,
         Viewer: {
            VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
                viewer_message: "Você já começou a assistir esse video, o que deseja fazer? ",
                viewer_bt_restart: "recomeçar",
                viewer_bt_continue: "continuar assistindo",
                viewer_back_color: "#f60909",
                viewer_color_text: "#f1f2f2",
                id_vsl: 182
            },
            errorMessage: null,

        }
    },

    methods: {
        adicionarEstilo() {
            fetch(`${this.VUE_APP_HOST_API_BACKEND}/viewer`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: '{"id_vsl":"' + this.Viewer.id_vsl +
                    '","viewer_message":"' + this.Viewer.viewer_message +
                    '","viewer_bt_restart":"' + this.Viewer.viewer_bt_restart +
                    '","viewer_bt_continue":"' + this.Viewer.viewer_bt_continue +
                    '","viewer_back_color":"' + this.Viewer.viewer_back_color +
                    '","viewer_color_text":"' + this.Viewer.viewer_color_text +
                    '"}'
            })

                .then(response => {
                    this.$alert("adicionado com sucesso.")
                    return this.$router.push('');

                })
                .catch(err => console.error(err));
        },

    }
}


</script>
